import React from "react"

export const IconMoney = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.4 20.1H3.6C2.2 20.1 1 18.9 1 17.5V10.2C1 8.79998 2.2 7.59998 3.6 7.59998H16.4C17.8 7.59998 19 8.79998 19 10.2V17.5C19 18.9 17.8 20.1 16.4 20.1ZM3.6 9.59998C3.3 9.59998 3 9.89998 3 10.2V17.5C3 17.8 3.3 18.1 3.6 18.1H16.4C16.7 18.1 17 17.8 17 17.5V10.2C17 9.89998 16.7 9.59998 16.4 9.59998H3.6Z"
      fill="#7A7B81"
    />
    <path
      d="M22.0001 16.1C21.4001 16.1 21.0001 15.7 21.0001 15.1V6.7C21.0001 6.3 20.8001 6 20.5001 6H5.1001C4.5001 6 4.1001 5.6 4.1001 5C4.1001 4.4 4.5001 4 5.1001 4H20.5001C21.9001 4 23.0001 5.2 23.0001 6.7V15.1C23.0001 15.6 22.6001 16.1 22.0001 16.1Z"
      fill="#7A7B81"
    />
    <path
      d="M9.9998 17C8.1998 17 6.7998 15.6 6.7998 13.8C6.7998 12 8.1998 10.6 9.9998 10.6C11.7998 10.6 13.1998 12 13.1998 13.8C13.1998 15.6 11.7998 17 9.9998 17ZM9.9998 12.7C9.2998 12.7 8.7998 13.2 8.7998 13.9C8.7998 14.6 9.2998 15 9.9998 15C10.6998 15 11.1998 14.5 11.1998 13.8C11.1998 13.1 10.6998 12.7 9.9998 12.7Z"
      fill="#7A7B81"
    />
    <path
      d="M4.9002 14.5C5.28679 14.5 5.6002 14.1866 5.6002 13.8C5.6002 13.4134 5.28679 13.1 4.9002 13.1C4.5136 13.1 4.2002 13.4134 4.2002 13.8C4.2002 14.1866 4.5136 14.5 4.9002 14.5Z"
      fill="#7A7B81"
    />
    <path
      d="M15.0999 14.5C15.4865 14.5 15.7999 14.1866 15.7999 13.8C15.7999 13.4134 15.4865 13.1 15.0999 13.1C14.7133 13.1 14.3999 13.4134 14.3999 13.8C14.3999 14.1866 14.7133 14.5 15.0999 14.5Z"
      fill="#7A7B81"
    />
  </svg>
)
